<div class="container" *transloco="let t">
  <label for="photo" class="upload">{{ t('POPUPS.NEW-IMAGE.TAKE-PHOTO') }}</label>
  <input id="photo" type="file" accept="image/*" (input)="onImageAttached($event)" capture="environment">
  <hr>
  <label for="picture" class="upload">{{ t('POPUPS.NEW-IMAGE.CHOOSE-LIBRARY') }}</label>
  <input id="picture" type="file" accept="image/*" (input)="onImageAttached($event)" multiple>
  <div class="upload cancel" (click)="onCancel()">{{ t('COMMON.LABEL.CANCEL') }}</div>
</div>
